import { useCallback, useEffect, useMemo } from 'react';
import { isPayablIframe, isPayablSandboxIframe, isPlatronIframe, isSoftPayIframe } from '@helpers/payments';
import { AppFCC } from '@types';
import { usePending } from '@hooks/pending';
import { LoadingOverlay } from '@kit/loading-overlay';
import { paymentAggregatorIframeWidgetIframePayablClassName, paymentAggregatorIframeWidgetIframePayablSandboxClassName, paymentAggregatorIframeWidgetIframeSoftPayClassName, PaymentAggregatorIframeWidgetIframeStyled, paymentAggregatorIframeWidgetPayablClassName, paymentAggregatorIframeWidgetPayablSandboxClassName, paymentAggregatorIframeWidgetPlatronClassName, paymentAggregatorIframeWidgetSoftPayClassName, PaymentAggregatorIframeWidgetStyled } from './styled';
import { PaymentAggregatorIframeWidgetProps } from './types';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
export const PaymentAggregatorIframeWidget: AppFCC<PaymentAggregatorIframeWidgetProps> = props => {
  const {
    payFrameData,
    pending: originPending,
    onError
  } = props;
  const {
    src
  } = payFrameData ?? {};
  const title = 'Payment Frame';
  const [pending, setPending] = usePending(true);
  const load = useCallback(() => {
    setPending(false);
  }, [setPending]);
  const error = useCallback(() => {
    setPending(false);
    onError?.(src);
  }, [onError, setPending, src]);
  useEffect(() => {
    if (!src) {
      setPending(false);
      return;
    }
    setPending(true);
  }, [onError, setPending, src]);
  useEffect(() => {
    if (!src && !pending) {
      onError?.(src);
    }
  }, [onError, pending, src]);
  const className = useMemo(() => {
    return isPlatronIframe(src) ? paymentAggregatorIframeWidgetPlatronClassName : isPayablSandboxIframe(src) ? paymentAggregatorIframeWidgetPayablSandboxClassName : isPayablIframe(src) ? paymentAggregatorIframeWidgetPayablClassName : isSoftPayIframe(src) ? paymentAggregatorIframeWidgetSoftPayClassName : undefined;
  }, [src]);
  const iframeClassName = useMemo(() => {
    return isPayablSandboxIframe(src) ? paymentAggregatorIframeWidgetIframePayablSandboxClassName : isPayablIframe(src) ? paymentAggregatorIframeWidgetIframePayablClassName : isSoftPayIframe(src) ? paymentAggregatorIframeWidgetIframeSoftPayClassName : undefined;
  }, [src]);
  return _jsxs(PaymentAggregatorIframeWidgetStyled, {
    className: className,
    children: [originPending ? _jsx(LoadingOverlay, {}) : _jsx(PaymentAggregatorIframeWidgetIframeStyled, {
      className: iframeClassName,
      src: src,
      title: title,
      onLoad: load,
      onError: error,
      scrolling: isPayablSandboxIframe(src) ? undefined : isPayablIframe(src) ? 'no' : undefined
    }, src), !pending ? null : _jsx(LoadingOverlay, {})]
  });
};